import courseReservationService from '../../services/courseReservationService';

const state = {
  reservations: []
};

const getters = {
  allCourseReservations: state => state.reservations
};

const actions = {
  async fetchReservations({ commit }, filters = {}) {
    try {
      const response = await courseReservationService.getReservations(filters);
      commit('setReservations', response.data.data);
    } catch (error) {
      console.error('Store error:', error);
      commit('setReservations', []);
    }
  },

  async addReservation({ commit }, reservationData) {
    const response = await courseReservationService.addReservation(reservationData);
    commit('newReservation', response.data);
  },

  async updateReservation({ commit }, reservationData) {
    const { id, ...data } = reservationData;
    const response = await courseReservationService.updateReservation(id, data);
    commit('updateReservation', response.data);
  },

  async deleteReservation({ commit }, reservationId) {
    await courseReservationService.deleteReservation(reservationId);
    commit('removeReservation', reservationId);
  }
};

const mutations = {
  setReservations: (state, reservations) => {
    state.reservations = reservations || [];
  },
  newReservation: (state, reservationData) => state.reservations.push(reservationData),
  updateReservation: (state, updatedReservation) => {
    const index = state.reservations.findIndex(reservation => reservation.id === updatedReservation.id);
    if (index !== -1) {
      state.reservations.splice(index, 1, updatedReservation);
    }
  },
  removeReservation: (state, reservationId) => {
    state.reservations = state.reservations.filter(reservation => reservation.id !== reservationId);
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}; 